module.exports = __webpack_public_path__ + "img/81.dff96380.jpg";